import { Icon, IFormRender } from '@busybusy/webapp-react-ui';
import { ArrowDownIcon } from 'assets/icons';
import BasicPickerFormField from 'components/foundation/form-fields/BasicPickerFormField/BasicPickerFormField';
import { IBasicPickerValue } from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';
import { EquipmentSelectionOptions } from '__generated__/graphql';

export interface IRequireEquipmentFormFieldsProps<T extends IRequireEquipmentFormFieldsData> {
  form: IFormRender<T>;
}

export interface IRequireEquipmentFormFieldsData {
  equipmentSelectionRequirement: EquipmentSelectionOptions;
}

const basicPickerOptions: Array<IBasicPickerValue<EquipmentSelectionOptions>> = [
  { id: EquipmentSelectionOptions.Off, name: t('Off') },
  { id: EquipmentSelectionOptions.Recommended, name: t('Opt-Out Required') },
  { id: EquipmentSelectionOptions.Required, name: t('Require Equipment') },
];

export default function RequireEquipmentFormFields<T extends IRequireEquipmentFormFieldsData>({
  form,
}: IRequireEquipmentFormFieldsProps<T>) {
  return (
    <BasicPickerFormField
      name="equipmentSelectionRequirement"
      data={basicPickerOptions}
      form={form}
      closeButtonRender={() => (
        <span className="drop-icon">
          <Icon svg={ArrowDownIcon} />
        </span>
      )}
    />
  );
}
